// Support cross-origin workers
// Inspired by https://github.com/webpack/webpack.js.org/issues/6716
const createWorker = (
  workerEndpoint: string,
): [worker: Worker, destroyWorker: () => void] => {
  const objectURL = URL.createObjectURL(
    new Blob([`importScripts(${JSON.stringify(workerEndpoint)});`], {
      type: 'application/javascript',
    }),
  );
  const worker = new Worker(objectURL);
  return [
    worker,
    () => {
      worker.terminate();
      URL.revokeObjectURL(objectURL);
    },
  ];
};

export default createWorker;
